var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.5H4.5C3.94772 3.5 3.5 3.94772 3.5 4.5V19.5C3.5 20.0523 3.94772 20.5 4.5 20.5H19.5C20.0523 20.5 20.5 20.0523 20.5 19.5V10.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7996 3.72068C17.7605 2.75977 19.3184 2.75977 20.2793 3.72068C21.2402 4.68158 21.2402 6.23952 20.2793 7.20042L13.3198 14.1599C13.2511 14.2286 13.1636 14.2754 13.0684 14.2945L9.58863 14.9904C9.42729 15.0227 9.26049 14.9722 9.14414 14.8559C9.0278 14.7395 8.9773 14.5727 9.00956 14.4114L9.70551 10.9316C9.72457 10.8364 9.77139 10.7489 9.84009 10.6802L16.7996 3.72068ZM19.5834 4.41663C19.0068 3.84008 18.0721 3.84008 17.4955 4.41663L17.1476 4.7646L19.2354 6.85245L19.5834 6.50447C20.1599 5.92793 20.1599 4.99317 19.5834 4.41663ZM18.5394 7.5484L16.4516 5.46055L10.884 11.0281L12.9719 13.116L18.5394 7.5484ZM11.9737 13.5097L10.4903 12.0263L10.1194 13.8806L11.9737 13.5097Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.a52ac4e3031329d041476ba0466ee79b.svg";
export { ForwardRef as ReactComponent };